var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ height: "27", viewBox: "0 0 30 27", width: "30", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "mask",
      { id: "heart-svg", fill: "#fff" },
      React.createElement("path", { d: "M0 0h30v26.784H0z", fillRule: "evenodd" })
    ),
    React.createElement("path", { d: "M5.551 8.695a1 1 0 1 1-2 0 5.396 5.396 0 0 1 5.39-5.39 1 1 0 0 1 0 2 3.394 3.394 0 0 0-3.39 3.39m9.45 18.089s15-10.36 15-18.632C30 3.65 26.53 0 22.25 0 18.933 0 16.107 2.19 15 5.266 13.891 2.19 11.065 0 7.75 0 3.47 0 0 3.65 0 8.152c0 8.395 15 18.632 15 18.632", fill: "#fff", fillRule: "evenodd", mask: "url(#a)" })
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/likes_filled.svg